import { microServiceSecurityApi } from "./microServiceSecurityApi";

export const auth = microServiceSecurityApi.injectEndpoints({
    endpoints: (builder) => ({
        validateSession: builder.query({
            query: () => ({
                url: `/user/ValidateSession`,
                method: "POST",
                
            }),
            extraOptions: { maxRetries: 0 },
            keepUnusedDataFor: 0,
        }),
    })
});

export const {
    useValidateSessionQuery,
    useLazyValidateSessionQuery
} = auth;

